<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
          <h4 class="card-title">{{ $t('production_store.production_request') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
            <b-col xs="12" sm="12" md="5">
              <b-form-group
                class="row"
                label-cols-sm="3"
                :label="$t('globalTrans.fiscal_year')"
                label-for="fiscal_year_id"
              >
                <b-form-select
                  plain
                  v-model="search.fiscal_year_id"
                  :options="fiscalYearList"
                  id="fiscal_year_id"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="5">
              <b-form-group
                class="row"
                label-cols-sm="3"
                :label="$t('production_store.month')"
                label-for="month"
              >
                <b-form-select
                  plain
                  v-model="search.month"
                  :options="monthList"
                  id="month"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
        <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>

            </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('production_store.production_request_list')}}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive" v-if="dataReady">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(employee_name)="data">
                      <span class="capitalize">{{ getEmpName(data.item.sender_id) }}</span>
                    </template>
                    <template v-slot:cell(designation)="data">
                      <span class="capitalize">{{ getDesName(data.item.sender_id) }}</span>
                    </template>
                    <template v-slot:cell(target_date)="data">
                      {{ data.item.main_request.target_date | dateFormat }}
                    </template>
                    <template v-slot:cell(target_id)="data">
                      {{ data.item.main_request.target_id }}
                    </template>
                    <template v-slot:cell(status)="data">
                      <span class="badge badge-warning" v-if="data.item.status == 1">{{$t('globalTrans.pending')}}</span>
                      <span class="badge badge-warning" v-else-if="data.item.status == 3">
                        <!-- {{$t('globalTrans.pending')}} By {{ getNameReceiver(data.item.forward_request.receiver_id) }} -->
                        {{ currentLocale === 'bn' ?  getNameReceiver(data.item.forward_request.receiver_id) + ' দ্বারা ' + $t('globalTrans.pending') : $t('globalTrans.pending') + ' By ' + getNameReceiver(data.item.forward_request.receiver_id) }}
                      </span>
                      <span class="badge badge-danger" v-else>
                        {{ currentLocale === 'bn' ?  getNameReceiver(data.item.receiver_id) + ' দ্বারা ' + $t('globalTrans.rejected') : $t('globalTrans.rejected') + ' By ' + getNameReceiver(data.item.receiver_id) }}
                      </span>
                    </template>
                    <template v-slot:cell(details)="data">
                      <a href="javascript:" class="btn_table_action btn_green" v-b-modal.modal-1 @click="viewItem(data.item)" :title="$t('globalTrans.details')"><i class="fas fa-eye"></i></a>
                      <a href="javascript:" class="btn_table_action btn_blue" v-b-modal.modal-2 @click="editItem(data.item)" v-if="data.item.status  == 1" :title="$t('globalTrans.edit')"><i class="ri-ball-pen-fill"></i></a>
                      <a href="javascript:" class="btn_table_action btn_purple" v-b-modal.modal-3 @click="forward(data.item)" v-if="data.item.status  == 1" :title="$t('globalTrans.forward')"><i class="fas fa-forward"></i></a>
                      <a href="javascript:" class="btn_table_action btn_deep_blue" @click="approveDeny(1, data.item.prod_target_main_id)" v-if="data.item.status  == 1" :title="$t('globalTrans.approve')"><i class="fas fa-check"></i></a>
                      <a href="javascript:" class="btn_table_action btn_rad" @click="approveDeny(2, data.item.prod_target_main_id)" v-if="data.item.status  == 1" :title="$t('globalTrans.deny')"><i class="fa fa-ban"></i></a>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-1" size="lg" :title="$t('production_store.production_request') + ' ' + $t('globalTrans.details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <ViewRequest :id="viewItemId" />
    </b-modal>
    <b-modal id="modal-2" size="xl" :title="$t('production_store.production_target') + ' ' + $t('globalTrans.list')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <EditRequest :id="editItemId" />
    </b-modal>
    <b-modal id="modal-3" size="lg" :title="$t('production_store.forward')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <FormForward :id="forwardItemId" />
    </b-modal>
  </b-container>
</template>
<script>
import FormForward from './Forward'
import ViewRequest from './ViewRequest'
import EditRequest from './EditRequest'
import RestApi, { productionServiceBaseUrl, authServiceBaseUrl } from '@/config/api_config'
import { productionRequestListApi, userListApi, productionTargetRequestStatusUpdateApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import flatpickr from 'flatpickr'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    FormForward, ViewRequest, EditRequest
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        month: 0
      },
      forwardItemId: '',
      viewItemId: '',
      editItemId: '',
      dataReady: false,
      rows: [],
      swlmsg: ''
    }
  },
  computed: {
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('production_store.target_id'), class: 'text-center' },
          { label: this.$t('production_store.target_date'), class: 'text-center' },
          { label: this.$t('production_store.employee_name'), class: 'text-center' },
          { label: this.$t('production_configuration.designation'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.details'), class: 'text-center w-20' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'target_id' },
          { key: 'target_date' },
          { key: 'employee_name' },
          { key: 'designation' },
          { key: 'status' },
          { key: 'details' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'target_id' },
          { key: 'target_date' },
          { key: 'employee_name' },
          { key: 'designation' },
          { key: 'status' },
          { key: 'details' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
  },
  created () {
    this.allUserList()
    this.loadData()
  },
  mounted () {
    flatpickr('#from_date', {})
    flatpickr('#to_date', {})
  },
  methods: {
    approveDeny (status, id) {
      this.updateStatus(status, id)
    },
    forward (item) {
        this.forwardItemId = item.id
    },
    searchData () {
      this.loadData()
    },
    editItem (item) {
      this.editItemId = item.prod_target_main_id
    },
    viewItem (item) {
      this.viewItemId = item.prod_target_main_id
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, productionRequestListApi, params).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', response.data.data)
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getEmpName (userId) {
      const user = this.allUsers.find(user => user.value === userId)
      if (this.$i18n.locale === 'bn') {
        return user.text_bn
      } else {
        return user.text_en
      }
    },
    getDesName (userId) {
      const user = this.allUsers.find(user => user.value === userId)
      const desId = user.designation_id
      const desData = this.$store.state.commonObj.designationList.find(designation => designation.value === desId)
      if (this.$i18n.locale === 'bn') {
        return desData.text_bn
      } else {
        return desData.text_en
      }
    },
    async updateStatus (status, id) {
      if (status === 1) {
        this.swlmsg = window.vm.$t('production_store.accept_msg')
      } else {
        this.swlmsg = window.vm.$t('production_store.deny_msg')
      }
      window.vm.$swal({
        title: this.swlmsg,
        showCancelButton: true,
        confirmButtonText: window.vm.$t('globalTrans.yes'),
        cancelButtonText: window.vm.$t('globalTrans.no'),
        focusConfirm: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          const loadingState = { loading: false, listReload: true }
          RestApi.putData(productionServiceBaseUrl, `${productionTargetRequestStatusUpdateApi}/${id}/${status}`).then(response => {
            this.$store.dispatch('mutateCommonProperties', loadingState)
            if (response.success) {
              this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
              this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save'),
                color: '#D6E09B'
              })
            } else {
              this.$refs.form.setErrors(response.errors)
            }
          })
        }
      })
    },
    allUserList () {
      const users = RestApi.getData(authServiceBaseUrl, `${userListApi}`).then(response => {
          const userList = response.map((obj, index) => {
            return Object.assign({}, obj, {
              text: this.currentLocale === 'en' ? obj.text_en : obj.text_bn
            })
          })
          this.dataReady = true
          this.allUsers = userList
          return userList
      })
      return users
    },
    getNameReceiver (id) {
      const fisint = parseInt(id)
      const userName = this.allUsers.find(user => user.value === fisint)
      if (this.$i18n.locale === 'bn') {
        return userName.text_bn
      } else {
        return userName.text_en
      }
    }
  }
}
</script>
